import Image from 'next/legacy/image';
import Link from 'next/link';
import type { ArticleType } from 'service/article';

const FeaturedArticle = ({
  article,
}: {
  article: ArticleType & { imageHeight: number; imageWidth: number };
}) => {
  const {
    title,
    excerpt,
    type,
    date,
    thumbnail,
    href,
    category,
    imageHeight,
    imageWidth,
  } = article;

  return (
    <article className="relative mb-20 flex flex-col items-center gap-8 overflow-hidden rounded-2xl bg-pp-bg-secondary p-6 md:p-10 lg:flex-row">
      {/* Content */}
      <div className="flex-1">
        {/* Badge */}
        <span className="mb-6 inline-block rounded-2xl bg-pp-green-primary px-4 py-2 text-xs font-semibold text-white">
          ★ 注目記事
        </span>

        {/* Title */}
        <Link
          href={href}
          className="mb-6 block text-2xl font-bold leading-tight text-pp-text-primary transition-colors duration-200 hover:text-pp-green-primary md:text-4xl"
        >
          {title}
        </Link>

        {/* Excerpt */}
        <p className="mb-6 text-base leading-relaxed text-pp-text-secondary md:text-lg">
          {excerpt}
        </p>

        {/* Meta Information */}
        <div className="flex items-center gap-3 text-sm text-pp-text-tertiary">
          <span className="font-semibold text-pp-green-primary">{type}</span>
          <span>•</span>
          <span>{date}</span>
        </div>
      </div>

      {/* Featured Image */}
      <div className="flex flex-1 justify-center overflow-hidden rounded-xl">
        <Image
          src={thumbnail}
          alt={title}
          width={imageWidth ?? 1906}
          unoptimized
          height={imageHeight ?? 1534}
          className="rounded-xl"
        />
      </div>
    </article>
  );
};

export default FeaturedArticle;
